(function($) {

  return; 

  // const $sphere_overlay = jQuery('.sphere-overlay');
  // if( $sphere_overlay.length ) {

  //   // Elements
  //   const $sphere_overlay__panel = jQuery('.sphere-overlay--panel');
  //   const $sphere_close_button = jQuery('.sphere-close-button');
  //   const $sphere_video = $sphere_overlay.find('video');
  //   const $sphere_image = $sphere_overlay.find('.sphere-foreground-image-wrapper');
  //   const video = $sphere_video.get(0);
  //   const $body = jQuery('body');

  //   // Animation
  //   const timeline = gsap.timeline({'paused' : true });

  //     timeline.to( $sphere_video.get(0), { // element
  //       transform : 'translateY(30vh)', // effect
  //       duration : 3 // duur in sec.
  //     }, 0 ); // start in sec.

  //     timeline.to( $sphere_image.get(0), { 
  //       transform : 'scale(1)',
  //       duration : 3.5
  //     }, 0);

  //     timeline.to( $sphere_close_button.get(0), { 
  //       transform : 'translateX(0)',
  //       duration : .500
  //     }, 2.350 );

  //     timeline.to( $sphere_overlay__panel.get(0), { 
  //       transform : 'translateX(0)',
  //       duration : .500
  //     }, 2.350 );

  //   // Buttons open/close
  //   const $sphere_button = jQuery('.sphere-button');
  //   $sphere_button.on('click', function(e) {
  //     $body.addClass('sphere-overlay-showing');
  //     $sphere_overlay.fadeIn(350);
  //     video.currentTime = 0;
  //     video.play();
  //     timeline.restart();
  //     e.preventDefault();
  //     e.stopPropagation();
  //   });

  //   $sphere_close_button.on('click', function(e) { 
  //     $sphere_overlay.fadeOut(350);
  //     $body.removeClass('sphere-overlay-showing');
  //   });

  //   $sphere_overlay.on('click', function(e) { 
  //     e.stopPropagation();
  //   });

  //   $sphere_overlay.bind('scroll wheel mousewheel DOMMouseScroll', function(e) { 
  //     e.preventDefault();
  //     e.stopPropagation();
  //   });

  //   // Buttons > menu interaction
  //   const $sphere_dots = jQuery('.sphere-overlay [data-menu-slug]');
  //   const $sphere_menu_items = jQuery('.sphere-overlay [data-slug]');

  //   $sphere_dots.on('mouseenter', function(e) {
  //     let slug = $(this).attr('data-menu-slug');
  //     $sphere_overlay__panel.find('[data-slug='+slug+']').addClass('active');
  //   });

  //   $sphere_dots.on('mouseleave', function(e) {
  //     let slug = $(this).attr('data-menu-slug');
  //     $sphere_overlay__panel.find('[data-slug='+slug+']').removeClass('active');
  //   });

  //   $sphere_dots.on('click', function(e) {
  //     let slug = $(this).attr('data-menu-slug');
  //     let a = $sphere_overlay__panel.find('[data-slug='+slug+'] > a');
  //     a.get(0).click();
  //   });

  //   // Menu > buttons interaction
  //   $sphere_menu_items.on('mouseenter', function(e) {
  //     let slug = $(this).attr('data-slug');
  //     $sphere_overlay.find('[data-menu-slug='+slug+']').addClass('active');
  //   });

  //   $sphere_menu_items.on('mouseleave', function(e) {
  //     let slug = $(this).attr('data-slug');
  //     $sphere_overlay.find('[data-menu-slug='+slug+']').removeClass('active');
  //   });

  // }

})(jQuery);